import { baseApi } from './baseApi';

/**
 * Zendesk Sync API endpoints
 * Handles automatic sync triggering and status monitoring
 */
export const zendeskSyncApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // POST /zendesk-sync - Trigger sync
    triggerSync: builder.mutation({
      query: (types = ['deals', 'contacts', 'tasks']) => ({
        url: '/zendesk-sync',
        method: 'POST',
        body: { types },
      }),
      invalidatesTags: [
        { type: 'ZendeskSync', id: 'STATUS' },
        { type: 'ZendeskSync', id: 'LAST' },
        { type: 'Deal', id: 'LIST' },
        { type: 'ZendeskContact', id: 'LIST' },
        { type: 'ZendeskContact', id: 'STATS' },
      ],
    }),

    // GET /zendesk-sync/status - Get sync status
    getSyncStatus: builder.query({
      query: (syncId = null) => {
        const params = syncId ? { sync_id: syncId } : {};
        return {
          url: '/zendesk-sync/status',
          params,
        };
      },
      providesTags: [{ type: 'ZendeskSync', id: 'STATUS' }],
    }),

    // GET /zendesk-sync/last - Get last completed sync
    getLastSync: builder.query({
      query: () => '/zendesk-sync/last',
      providesTags: [{ type: 'ZendeskSync', id: 'LAST' }],
    }),
  }),
});

export const {
  useTriggerSyncMutation,
  useGetSyncStatusQuery,
  useGetLastSyncQuery,
} = zendeskSyncApi;
